import { render } from "./Header.vue?vue&type=template&id=5876f3f9"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=5876f3f9&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script